import { getParameters } from '../../../helpers/helpers';

import HandleNewTerminalForm from './addNewTerminal/handle-new-terminal';
import { getIndividualTerminal } from './displayTerminal/get-terminal-info';
import { updateTerminal } from './updateTerminal/update-terminal';

/**
 * Direct terminal form functionality based on terminalAction param.
 * 
 * @returns void
 */
export const formTerminal = async () => {
  const terminalForm = document.querySelector('.aafp_terminal-form') as HTMLElement;
  if ( !terminalForm ) return;

  const formAction = getParameters('terminalAction');
  const terminal = getParameters('terminalID');
  const partner = getParameters('partnerID');

  switch(formAction) {
    case 'add':
      HandleNewTerminalForm();
      break;
    case 'edit':
      const { body } = await getIndividualTerminal(terminal, partner);
      updateTerminal(terminal, body);
      break;
    case 'view':
      getIndividualTerminal(terminal, partner);
      break;
  }
}

